module.exports = __webpack_public_path__ + "img/award_temp_img2.7af65a42.jpg";